import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fc } from 'i18n';
import { Contacts } from './cotacts';
import { EntryPasses } from './entry-passes';
import { Tabs } from 'components/molecules/tabs';
import { close as closeSign } from 'assets/icons';
import { Preloader } from 'components/atoms/preloader';
import { NOTIFY_OFFICERS_TABS } from 'constants/table';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { ModalWrapper } from 'components/molecules/modal-wrapper';
import { notifyOfficersModalSelector } from 'core/redux/selectors/tep';
import { actions as leasesActions } from 'core/redux/api/veta/tep/leases';
import { actions as officersActions } from 'core/redux/api/veta/tep/officers';
import { actions as notificationsActions } from 'core/redux/api/veta/tep/notifications';

import styles from './styles.module.css';

export const NotifyOfficersModal: FC = () => {
  const dispatch = useDispatch();

  const { isLoading, leases } = useSelector(notifyOfficersModalSelector);

  const [tab, setTab] = useState<string>(NOTIFY_OFFICERS_TABS[0].id);

  const close = () => {
    dispatch(leasesActions.close());
    dispatch(officersActions.cancel());
    dispatch(notificationsActions.cancel());
  };

  const onBack = () => {
    setTab(NOTIFY_OFFICERS_TABS[0].id);
  };

  const onNext = () => {
    setTab(NOTIFY_OFFICERS_TABS[1].id);
  };

  return (
    <ModalWrapper>
      <div className={styles.content}>
        <span className={styles.close} onClick={close}>
          <SvgWrapper width={26} height={26} details={closeSign} />
        </span>
        <div className={styles.title}>{fc('Notify Enforcement Officers')}</div>
        <Tabs tabs={NOTIFY_OFFICERS_TABS} currentTabId={tab} setCurrentTabId={setTab} />
        {tab === NOTIFY_OFFICERS_TABS[0].id ? (
          <EntryPasses count={leases.length} onNext={onNext} />
        ) : (
          <Contacts onBack={onBack} />
        )}
        {isLoading && <Preloader />}
      </div>
    </ModalWrapper>
  );
};
